import { createModel } from "hox";
import { TablePaginationConfig } from "antd/es/table/interface";
import { IPgProps, ISearchPage } from "@/types/ScmTypes";
import React, { useState } from "react";
import { PaginationProps } from "antd/es/pagination";
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE, defaultMdCmParam } from "@/utils/constants";
import { IStockStatisticFields, IStockStatisticSearch, IStockStatisticDetail, stockStatisticService, IInventoryTotal } from "./stockStatisticService"
import useGlobalModel, { transOptions } from "@/model/globalModel";
import { IShelfFileds, warehouseService } from "../../base/warehouse/warehouseService"
import { convertRes2Blob } from "@/utils/exportFile";
export function transPgToPagination(pg: IPgProps): PaginationProps {
    return {
        total: pg.total,
        pageSize: pg.size,
        current: pg.pageNum
    }
}

export const useStockStatisticModel = createModel(function () {
    const { stockData, setStockData } = useGlobalModel()
    const initSearchParam: IStockStatisticSearch = {};
    const initDataSource: IStockStatisticDetail[] = [];
    const initDesc: IInventoryTotal = {
        averageAmount: 0,
        latestAmountTotal: 0,
        total: 0,
        type: 0
    }

    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    //查询条件
    const [searchParam, setSearchParam] = useState<IStockStatisticSearch>(initSearchParam);
    //列表数据源
    const [dataSource, setDataSource] = useState<IStockStatisticDetail[]>(initDataSource);
    //表格选中行Key值
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
    //列表数据源分页参数
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);
    //
    const [descTotal, setDescTotal] = useState<IInventoryTotal>(initDesc);

    const [shelfList, setShelfList] = useState<IShelfFileds[]>([])

    const [drawerVisible, setDrawerVisible] = useState(false);

    const updatePgCfg = (updateParam: TablePaginationConfig) => {
        setPgCfg({ ...pgCfg, ...updateParam })
    }
    const updateSearchParam = async (updateParam: IStockStatisticFields) => {
        let newUpdateParam: IStockStatisticFields = updateParam;
        if ("warehouseCode" in updateParam) {
            setShelfList([])
            let { warehouseCode, materialCode, materialName, brandCode, shelfCode, isEqual } = updateParam
            let params = {
                pageSize: 1000,
                pageNum: 1,
                warehouseCode
            }
            const { retData } = await warehouseService.shelfPage(params)
            const { records, ...pg } = retData;
            const newRecords = records.map((item: IShelfFileds) => { return { ...item, name: item.code } })
            setShelfList(newRecords ?? [])
            newUpdateParam = { ...updateParam, shelfCode: null }
            console.log(newUpdateParam)
        }
        setSearchParam({ ...searchParam, ...newUpdateParam })
    }
    const resetSearchParam = () => {
        setSearchParam(initSearchParam);
        loadData(initPgCfg, {});
        setSelectedRowKeys([])
    }
    //加载所有库存
    const loadStockAllData = async () => {
        const params = {
            pageSize: 9999,
            pageNum: 1
        }
        let { retData } = await stockStatisticService.page(params);
        const { records, ...pg } = retData;
        setStockData(records)
    }
    const loadData = async (page?: ISearchPage, searchValue: IStockStatisticSearch = searchParam) => {
        console.log(searchValue)
        const searchParams = {
            ...searchValue,
            pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: page?.pageNum ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,

        }
        let { retData } = await stockStatisticService.pages(searchParams);
        const { inventoryTotal, list } = retData[0];
        const { records, ...pg } = list;
        let newPg = { ...pg, pageNum: pg.current }
        setDescTotal(inventoryTotal)
        setPgCfg(transPgToPagination(newPg));
        setDataSource(records);
    }
    //列表导出
    const listExport = async () => {
        let result = await stockStatisticService.export({ ...searchParam, pageSize: 999999, pageNum: 1 });
        convertRes2Blob(result)
    }
    return {
        /***field***/
        searchParam,
        dataSource,
        selectedRowKeys,
        pgCfg,
        drawerVisible,
        shelfList,
        descTotal,
        /***method***/
        setDataSource,
        setSelectedRowKeys,
        resetSearchParam,
        updateSearchParam,
        loadData,
        updatePgCfg,
        setDrawerVisible,
        loadStockAllData,
        setShelfList,
        setDescTotal,
        listExport
    }
});